"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToCartV2 = exports.removeCartItem = exports.addToCart = exports.getId = exports.getShopProduct = void 0;
var ShopProduct_1 = require("../../classes/ShopProduct");
var ShopProductSelection_1 = require("../../classes/ShopProductSelection");
var collection_1 = require("../shopify-graphql/collection");
var getCollectionDataByLocation = function (loc) { return __awaiter(void 0, void 0, void 0, function () {
    var handle;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                handle = loc.pathname.split('/')[2];
                if (!loc.pathname.includes('/collections')) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, collection_1.queryCollectionByHandle)(handle)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                if (!loc.pathname.includes('/products')) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, collection_1.queryProductWithCollectionByHandle)(handle)];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                if (!loc.pathname.includes('/pages')) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, collection_1.queryPageWithCollectionByHandle)(handle)];
            case 5: return [2 /*return*/, _a.sent()];
            case 6:
                console.error('this method can be only used for collection, product or page template');
                return [4 /*yield*/, (0, collection_1.queryCollectionByHandle)('pms')];
            case 7: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var getShopProduct = function (loc) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, collection, product;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getCollectionDataByLocation(loc)];
            case 1:
                _a = _b.sent(), collection = _a.collection, product = _a.product;
                if (collection) {
                    return [2 /*return*/, new ShopProductSelection_1.ShopProductSelection(collection, product)];
                }
                else if (product) {
                    return [2 /*return*/, new ShopProduct_1.ShopProduct([product])];
                }
                throw new Error('could not create a shopProduct because both collection & product are missing');
        }
    });
}); };
exports.getShopProduct = getShopProduct;
var getId = function (id) {
    if (!id) {
        return undefined;
    }
    return id.split('/').pop();
};
exports.getId = getId;
var reverseCartItems = function (cart) {
    cart.items = cart.items.reverse();
    return cart;
};
//use this function to add product to cart
var addToCart = function (variant) { return __awaiter(void 0, void 0, void 0, function () {
    var data, err_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                data = {
                    items: [
                        {
                            id: (0, exports.getId)(variant.id),
                            quantity: 1,
                            selling_plan: (0, exports.getId)((_b = (_a = variant.sellingPlanAllocations) === null || _a === void 0 ? void 0 : _a.nodes[0]) === null || _b === void 0 ? void 0 : _b.sellingPlan.id),
                        },
                    ],
                };
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data),
                    })];
            case 2:
                _c.sent();
                document.dispatchEvent(new Event('fetchAndSlideCart'));
                return [3 /*break*/, 4];
            case 3:
                err_1 = _c.sent();
                console.error('Error:', err_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.addToCart = addToCart;
var removeCartItem = function (replacedItemId) { return __awaiter(void 0, void 0, void 0, function () {
    var data, response, cartData, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                data = {
                    updates: (_a = {},
                        _a[replacedItemId] = 0,
                        _a),
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data),
                    })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                cartData = _b.sent();
                return [2 /*return*/, reverseCartItems(cartData)];
            case 4:
                e_1 = _b.sent();
                console.error('cart remove error', e_1);
                console.error('Error:', e_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.removeCartItem = removeCartItem;
var addToCartV2 = function (variant, quantity) { return __awaiter(void 0, void 0, void 0, function () {
    var data, err_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                data = {
                    items: [
                        {
                            id: (0, exports.getId)(variant.id),
                            quantity: quantity,
                            selling_plan: (0, exports.getId)((_b = (_a = variant.sellingPlanAllocations) === null || _a === void 0 ? void 0 : _a.nodes[0]) === null || _b === void 0 ? void 0 : _b.sellingPlan.id),
                        },
                    ],
                };
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(data),
                    })];
            case 2:
                _c.sent();
                return [3 /*break*/, 4];
            case 3:
                err_2 = _c.sent();
                console.error('Error:', err_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.addToCartV2 = addToCartV2;
